var typeahead = {

	elms: {
		typeaheadInput: $('.typeahead')
	},

	setUpTypeahead: function(itemsArr) {

		var substringMatcher = function(strs) {

			return function findMatches(q, cb) {

				var matches, substrRegex;

				// an array that will be populated with substring matches
				matches = [];

				// regex used to determine if a string contains the substring `q`
				substrRegex = new RegExp(q, 'i');

				// iterate through the pool of strings and for any string that
				// contains the substring `q`, add it to the `matches` array
				$.each(strs, function(i, str) {
					if (substrRegex.test(str)) {
						matches.push(str);
					}
				});

				cb(matches);
			};
		};


		var $typeaheadInput = typeahead.elms.typeaheadInput;

		// console.log(itemsArr);

		// Set up Twitter Typeahead plugin
		$typeaheadInput.typeahead({
			hint: true,
			highlight: true,
			minLength: "1"
		},
		{
			name: 'itemsArr',
			source: substringMatcher(itemsArr)
		});

		// Close typeahead on enter
		$(document).keypress(function(e) {
			if (e.which === 13) {
				$typeaheadInput.typeahead('close');
			}
		});
	},

	init: function(itemsArr) {
		// If typeahead input is present
		if (typeahead.elms.typeaheadInput) {
			typeahead.setUpTypeahead(itemsArr);
		}
	}
};